import React from 'react';
import './CustomWheelFrame.css';

const LIGHT_COUNT = 12;

const CustomWheelFrame = ({ children, size = 'default' }) => {
    const sizeClass = size === 'tv' ? 'custom-wheel-frame--tv' : '';

    return (
        <div className={`custom-wheel-frame ${sizeClass}`}>
            <div className="custom-wheel-outer">
                <div className="custom-wheel-lights" aria-hidden="true">
                    {Array.from({ length: LIGHT_COUNT }).map((_, index) => (
                        <span
                            key={index}
                            className="custom-wheel-light"
                            style={{ transform: `rotate(${index * (360 / LIGHT_COUNT)}deg) translateY(var(--light-radius))` }}
                        />
                    ))}
                </div>

                <div className="custom-wheel-disc">
                    {children}
                </div>

                <div className="custom-wheel-hub" aria-hidden="true">
                    <span className="custom-wheel-star">★</span>
                </div>

                <div className="custom-wheel-pointer" aria-hidden="true" />
            </div>
        </div>
    );
};

export default CustomWheelFrame;
